import { z } from 'zod'
import {
  Customer,
  ErpCustomerSchema,
  ErpStoreSchema,
  Staff,
  StaffSchema,
  Store,
  StoreSchema,
} from './erp'
import {
  CustomerPoliciesState,
  CustomerPoliciesStateSchema,
} from '../../schema/CustomerSchema'
import { ServerContext } from './serverCtx'

export const VerifyStrategyType = z.enum(['phone', 'email', 'qr', 'staff'])

export type VerifyStrategyType = z.infer<typeof VerifyStrategyType>

export const LoginStrategyConfig = z.object({
  strategy: VerifyStrategyType,
  maskedLogin: z.string(),
})

export type LoginStrategyConfig = z.infer<typeof LoginStrategyConfig>

export const VerifyRequestResponse = z.object({
  login: z.string(),
  status: z.literal('ok'),
  strategy: VerifyStrategyType,
  availableStrategies: z.array(LoginStrategyConfig),
})

export type VerifyRequestResponse = z.infer<typeof VerifyRequestResponse>

export const CustomerLoginResponse = z.object({
  data: ErpCustomerSchema,
  policies: CustomerPoliciesStateSchema.optional(),
  token: z.string(),
  exp: z.number(),
  refresh_token: z.string(),
  refresh_exp: z.number(),
})

export const LoginWithCodeRequest = z.object({
  login: z.string(),
  id: z.number().optional(),
  strategy: VerifyStrategyType,
  code: z.string(),
})

export type LoginWithCodeRequest = z.infer<typeof LoginWithCodeRequest>

export const StoreLoginResponse = z.object({
  data: StoreSchema,
  token: z.string(),
  exp: z.number(),
  refresh_token: z.string(),
  refresh_exp: z.number(),
})

export const StaffLoginResponse = z.object({
  data: StaffSchema,
  store: StoreSchema.optional(),
  token: z.string(),
  exp: z.number(),
  refresh_token: z.string(),
  refresh_exp: z.number(),
})

export type TokenResponse = {
  refresh_token: string
  refresh_exp: number
  token: string
  exp: number
}

export type LoginResponse<T> = TokenResponse & {
  data: T
}

export type CustomerLoginResponse = LoginResponse<Customer> & {
  policies?: CustomerPoliciesState
}
export type StoreLoginResponse = LoginResponse<Store>
export type StaffLoginResponse = LoginResponse<Staff> & {
  store?: Store
}

export type VerifyUserStrategy = (
  input: Customer,
  ctx: ServerContext
) => Promise<VerifyRequestResponse>
